import { render, staticRenderFns } from "./create-subpackage.vue?vue&type=template&id=956ec1e0&scoped=true&"
import script from "./create-subpackage.vue?vue&type=script&lang=js&"
export * from "./create-subpackage.vue?vue&type=script&lang=js&"
import style0 from "./create-subpackage.vue?vue&type=style&index=0&id=956ec1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956ec1e0",
  null
  
)

export default component.exports